<div *ngIf="currentMotivo">
  <div class="ticket-info horarios-info">
    <div class="inputControl TicketsPasos">
      <a
        title="Previo"
        class="prev"
        (click)="prev()"
        *ngIf="!comprobarLimitePrev()"
      >
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
      </a>
      <span class="titulo"
        >{{ 'MOTIVO_DESCUENTO' | translateV2 }} {{ currentClienteIndex }}º
        {{ 'PERSONA' | translateV2 }}
        <span *ngIf="currentMotivo.motivo.cantidad > 1"
          >({{ currentClienteIndex }} {{ 'DE_OF' | translateV2 }}
          {{ currentMotivo.motivo.cantidad }})</span
        ></span
      >
      <span class="resumen"
        >{{ currentMotivo.motivo.Entrada.NombreDispay }}
        <span *ngIf="motivos.length > 1"
          >({{ currentMotivoIndex + 1 }} {{ 'DE_OF' | translateV2 }}
          {{ motivos.length }})</span
        ></span
      >
      <a
        title="Próximo"
        class="next"
        (click)="next()"
        *ngIf="!comprobarLimiteNext()"
      >
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
      </a>
    </div>
  </div>
  <div class="onoffswitch-wrapGeneral enMotivos">
    <div
      class="onoffswitch-wrap checked"
      *ngIf="currentMotivo.motivo.cantidad > 1"
    >
      <div class="onoffswitch">
        <input
          type="checkbox"
          name="onoffswitch03"
          id="myonoffswitch03"
          class="onoffswitch-checkbox"
          (click)="onOffSwitch()"
          [checked]="aplicarTodos"
        />
        <label class="onoffswitch-label" for="myonoffswitch03"></label>
      </div>
      <label class="onoffswitch-label-text" for="myonoffswitch03"
        >{{ 'APLICAR_1' | translateV2 }} ({{ currentMotivo.motivo.cantidad }})
        {{ 'APLICAR_2' | translateV2 }}</label
      >
    </div>
  </div>

  <div class="motivosWrap">
    <div class="motivos">
      <div
        class="Rtable-cell motivo-cell"
        *ngFor="let descuento of currentMotivo.descuentosAplicables"
        (click)="aplicarDescuentoMotivo(descuento)"
        [ngClass]="{ select: isSelected(descuento) }"
      >
        <div class="Rtable-cell--content motivo-content">
          {{ descuento.Nombre }}
        </div>
      </div>
    </div>
  </div>

  <!-- <ticketing-table #selection *ngIf="motivoStringList.length !== 0">
      <div *ngFor="let motivo of motivoStringList">
        <ticketing-motivo [isSelected]="false" name='{{motivo}}' (click)="next()"></ticketing-motivo>
      </div>
    </ticketing-table> -->

  <ul class="pagination" *ngIf="pager.pages && pager.pages.length > 1">
    <li>
      <a (click)="setPage(pager.currentPage - 1)" title="Previo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
      </a>
    </li>
    <li *ngFor="let page of pager.pages">
      <a
        (click)="setPage(page)"
        [ngClass]="{ active: pager.currentPage === page }"
        >{{ page }}</a
      >
    </li>
    <li>
      <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
      </a>
    </li>
  </ul>
</div>
